import * as React from 'react';
import { ErrorInfo } from "react";

interface MapPopupErrorBoundaryState {
  hasError: boolean;
}

export default class MapPopupErrorBoundary extends React.Component<any, MapPopupErrorBoundaryState> {
  constructor(props: any) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    // Mettez à jour l'état, de façon à montrer l'UI de repli au prochain rendu.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('could not render popup', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Vous pouvez afficher n'importe quelle UI de repli.
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}